import fetch from 'utils/fetch'

export const bindOperation = params => {
    return fetch({
        url: '/operation/bind',
        data: params,
        method: 'POST',
    })
}

export const changeOpenId = params => {
    return fetch({
        url: '/operation/changeopenid',
        data: params,
        method: 'POST',
    })
}

// adType=2(腾讯广告投放)
export const autoChangeOpenId = params => {
    return fetch({
        url: '/operation/autoChangeopenid',
        data: params,
        method: 'POST',
    })
}
// 请求子客信息或直客信息
export const getAgencyInfoList = params => {
    return fetch({
        url: '/operation/agency',
        data: params,
        method: 'POST',
    })
}
// 请求服务商信息
export const getAccountInfo = params => {
    return fetch({
        url: '/operation/account',
        data: params,
        method: 'POST',
    })
}
